<script setup>
import { computed, nextTick } from 'vue';
import PdInput from './PdInput.vue';

const model = defineModel({ type: String, default: '' });
// Pasted numbers often carry +91, 91, a leading 0 or spaces. Keep only the 10 digit number.
function clean(v) {
  let d = String(v || '').replace(/\D/g, '');
  if (d.length > 10 && d.startsWith('91')) d = d.slice(2);
  if (d.length > 10 && d.startsWith('0')) d = d.slice(1);
  if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  return d.slice(0, 10);
}
// Set the raw text first, then the clean value, so the field always re-renders the clean
// value even when it did not change (for example an 11th digit typed into a full number).
const value = computed({
  get: () => model.value,
  set: (v) => {
    const c = clean(v);
    if (c === v) { model.value = c; return; }
    model.value = v;
    nextTick(() => { model.value = c; });
  },
});
defineProps({
  id: { type: String, default: null },
  invalid: { type: Boolean, default: false },
  placeholder: { type: String, default: 'Enter your 10 digit number' },
});
</script>

<template>
  <PdInput
    :id="id"
    v-model="value"
    prefix="+91"
    type="tel"
    inputmode="numeric"
    autocomplete="tel-national"
    :placeholder="placeholder"
    :invalid="invalid"
  >
    <template #action><slot name="action" /></template>
  </PdInput>
</template>
